import type { Recurrence } from '@lingoda/dates';
import { transChoice } from '@lingoda/i18n';

export const getValidityPeriod = (creditsValidityInterval?: Recurrence) => {
    if (creditsValidityInterval) {
        const { d, m, y } = creditsValidityInterval;

        if (d) {
            return transChoice('valid-for-day', d, { days: d }, 'public-courses');
        } else if (m) {
            return transChoice('valid-for-month', m, { months: m }, 'public-courses');
        } else if (y) {
            return transChoice('valid-for-year', y, { years: y }, 'public-courses');
        }
    }

    return transChoice('valid-for-month', 1, {}, 'public-courses');
};
